import * as React from 'react';
import type { SVGProps } from 'react';
const IconNewsFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconNewsFilled"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 21H5a3 3 0 0 1-3-3V3h16v7h4v8a3 3 0 0 1-3 3M6 8v2h8V8zm12 4v6a1 1 0 1 0 2 0v-6zM6 13v2h8v-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconNewsFilled;
